'use strict';

module.exports = {
    SIGN: 'חתום',
    SIGN_JOIN: 'היכנסו או הצטרפו בחינם!',
    EMAIL_EXISTS: 'כתובת הדוא"ל הזו כבר קיימת',
    INVALID_EMAIL: ' אנא הכנס כתובת דוא"ל תקינה',
    INVALID_FIRST_NAME: 'אנא הזן שם פרטי חוקי',
    INVALID_LAST_NAME: 'אנא הזן שם משפחה חוקי',
    INVALID_PASSWORD: ' אנא הזן בין 6-20 תווים בלבד (א-ת, 0-9 בלבד)',
    INVALID_REPASSWORD: 'הסיסמאות אינן זהות ',
    INVALID_VALID_CODE: 'אנא הזן קוד חוקי',
    UNAVIALABLE_SERVICE: 'השירות אינו זמין. אנא נסה שוב במועד מאוחר יותר',
    EMPTY_VALID_CODE: 'הקלד את התווים שאתה רואה בתמונה',
    NOT_MEMBER: 'לא רשום כחבר?',
    ALREADY_MEMBER: 'רשום במועדון החברים של AliExpress/Alibaba?',
    EMAIL: 'כתובת דוא"ל',
    CONTACT_NAME: 'שם איש קשר:',
    FIRST_NAME: 'שם פרטי',
    LAST_NAME: 'שם משפחה',
    PASSWORD: 'סיסמא',
    REPASSWORD: 'הזן שוב סיסמא:',
    EMPTY_CODE: 'הזן את הקוד המוצג:',
    REFRESH: 'רענון',
    CREATE_MY_ACCOUNT: 'צור חשבון',
    NAME: 'שם',
    VERIFICATION: 'קוד אימות',
    AGREE_MENT: 'ע"י יצירת חשבון הנך מסכים לתנאים הבאים',
    AE_MEMBER_SHIP: 'הצטרפות בחינם למועדון הלקוחות של AliExpress.com',
    AND: 'ו',
    PRIVACY_POLICY: 'מדיניות פרטיות',
    SLIDE_SUBMIT: 'החלק ימינה כדי לאשר',
    SLIDE_SUBMIT_TIPS: 'הצלחה',
    LOADING: 'טוען...',
    SLIDE_SUBMIT_ERROR_TIPS: 'החלק ימינה כדי לאשר',
    SHOP_NOW: 'קנה כעת',
    SIGN_IN: 'היכנס',
    REGISTER_SMS: 'הירשמו באמצעות SMS',
    REGISTER_EMAIL: 'הירשמו באמצעות דוא"ל',
    PHONE_NUMBER: 'מספר טלפון',
    VALID_NUMBER: 'נא הזינו מספר טלפון תקף',
    SEND_SMS_CODE: 'שלחו קוד SMS',
    SMS_POLICY: 'אנו נשלח קוד אימות באמצעות SMS למספר הטלפון שהזנתם. יש לוודא שקוד המדינה ומספר הטלפון נכונים.',
    SEND_TO: 'שלחנו את הקוד אל',
    VERIFICATION_RECEIVED: 'הזינו את קוד האימות שקיבלתם או',
    EDIT_NUMBER: 'ערכו את המספר.',
    RESEND_CODE: 'שלחו שוב את הקוד',
    LAST_STEP: 'שלב אחרון',
    SET_SIGN_IN_PASSWORD: 'הגדירו סיסמת כניסה לאבטחת החשבון.',
    INVALID_PHONE_PASSWORD: '20-6 תווים (אותיות וספרות בלבד)',
    NOT_CORRECT_CODE: 'הקוד שגוי. נסו שוב.',
    SAVE_PASSWORD: 'שמירת סיסמה',
    NO_RECEIVED_CODE: 'אם עדיין לא קיבלתם את הקוד, נסו',
    VIA_EMAIL: 'הרשמה באמצעות דוא"ל'
};